module.exports = require('./dist/angular-material-event-calendar');



//////////////////
// WEBPACK FOOTER
// ./~/angular-material-event-calendar/index.js
// module id = 387
// module chunks = 0